var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pv20"},[(_vm.noMore)?_c('p',{staticClass:"center"},[_vm._v("没有更多")]):_c('p',{staticClass:"center"},[_c('i',{staticClass:"el-icon-loading"}),_c('span',[_vm._v(_vm._s(_vm.loadText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }